import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import i18next from 'i18next';

import { DATA_TEST_ID } from '~constants/tests';
import ModalActions from '~redux/Modal/actions';
import NextUpActions from '~redux/NextUp/actions';
import { MODALS } from '~redux/Modal/constants';

import styles from './styles.module.scss';
import { TEMPLATE_MODEL_CONFIG } from './constants';

function MiniCart() {
  const dispatch = useDispatch();
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const cartItems = useSelector((state) => state.cart.cart);
  const { templateModel } = useSelector((state) => state.core);
  const config = TEMPLATE_MODEL_CONFIG[templateModel];
  const address = useSelector((state) => state.auth.address?.current?.textAddress);

  const openMiniCartMenu = () => {
    if (!address) {
      dispatch(NextUpActions.setNextAction(ModalActions.openModal(MODALS.MINI_CART)));
    }
    dispatch(ModalActions.openModal(address ? MODALS.MINI_CART : MODALS.DELIVERY_OR_PICKUP));
  };

  const cartItemsQ = cartItems.reduce((acc, el) => acc + el.count, 0);

  const displayQuantity = () => {
    const quantityToShow = cartItemsQ === 0 && !config.show0Quantity ? '' : cartItemsQ;
    return config.hasItemsLabel ? i18next.t('Cart:quantity', { quantity: quantityToShow }) : quantityToShow;
  };

  return (
    <button
      type="button"
      className={cn(styles[`miniCartContainer${templateModel}`], {
        [styles.secondaryHeader]: isSecondaryHeader
      })}
      onClick={openMiniCartMenu}
      data-testid={DATA_TEST_ID.openCart}>
      <span className={`material-icons-outlined ${styles.cartIcon}`}>
        {TEMPLATE_MODEL_CONFIG[templateModel].cartIcon}
      </span>
      <span>{displayQuantity()}</span>
    </button>
  );
}

export default MiniCart;
